<template>
  <a-modal :name="'respond-check-complete-'+result.id">
    <div  class="respond-complete" @click.self="closeModal">
      <div class="bg-color" @click.self="closeModal"></div>
      <form class="respond-complete-modal">
        <h2 class="respond-complete-modal__title">
          {{result.messages.title}}
        </h2>
        <div class="volunteer">
          <div class="avatar">
            <AAvatar width="50" :src="result.volunteer.photo" class="ChatMessage__avatar"/>
          </div>
          <div class="name">{{result.volunteer.name}}</div>
        </div>
        <p class="respond-application-modal__text">
          {{result.messages.subTitle}}
        </p>
        <section class="respond-application-modal__text mb-3">
          <div class="subTitle">
            {{result.messages.textTitle}}
          </div>
          {{result.text}}
        </section>
        <section class="respond-application-modal__text mb-3">
          <div class="subTitle">
            {{result.messages.timeTitle}}
          </div>
          {{result.time}}
        </section>
        <section class="respond-application-modal__text mb-3">
          <div class="subTitle">
            {{result.messages.fileTitle}}
          </div>
          <UserFiles :items="result?.files"
          >
            <template #actions="{index}">
              <a class="user-files__remove-btn" :href="result?.files[index].link" target="_blank">{{result.messages.btnDownload}}</a>
            </template>
          </UserFiles>
        </section>
         <div class="respond-complete-buttons">
          <ABtn :label="result.btns.complete.title" bg="#00A59E" @click.prevent="CompleteAction"/>
          <ABtn @click.prevent="dopWork" class="respond-complete-reset" :label="result.btns.dopWork.title" bg="transparent" color="#00A59E" type="reset" />
        </div>
      </form>
    </div>
  </a-modal>
</template>

<script>
import {useAModal, AModal, AInput, ABtn, ACheckbox, useAProgressBar} from "~/components/ui";
import UserFiles from '~/components/cards/UserFiles.vue'
import {send} from "../../../services/api";
import {AAvatar} from "../../ui";
export default {
  name: "ResponseCheckComplete",
  props: ['result'],
  components: {
    AAvatar,
    AModal,
    ACheckbox,
    UserFiles,
    AInput,
    ABtn,
  },
  setup(props) {
    const modal = useAModal();
    const progress = useAProgressBar();
    const closeModal = () => {
      modal.hide();
    }
    const CompleteAction = async () => {
      progress.show();
      await send(props.result.btns.complete.action.link, {method: "POST"}, props.result.btns.complete.action.data).then((response) => {
        if (response.error) {
          showNotification("danger", '', response.error);
          progress.hide();
        } else {
          showNotification("success", '', response.success);
          setTimeout(() => {
            location.reload()
          }, 5000);
        }
      })

    }
    const dopWork = async () => {
      progress.show();
      await send(props.result.btns.dopWork.action.link, {method: "POST"}, props.result.btns.dopWork.action.data).then((response) => {
       if (response.error) {
          showNotification("danger", '', response.error);
          progress.hide();
        } else {
          showNotification("success", '', response.success);
          setTimeout(() => {
              if (response.link){
                  location.href = response.link;
              } else {
                  location.reload();
              }
          }, 5000);
        }
      })
    }

    return {
      dopWork,
      closeModal,
      CompleteAction,
    }
  }
}
</script>

<style lang="scss" scoped>
.volunteer {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .avatar {
    margin-right: 10px;
  }
}
.bg-color {
  width: 100%;
  height: 50vh;
  background: var(--c-secondary-200);
}
.subTitle {
  margin-bottom: 11px;
  font-size: 20px;
}
.respond-application-modal__text {
  font-size: 25px;
}
.respond-complete {
  min-height: 100vh;
  background-color: #fff;
}
.respond-complete-background{
  position: absolute;
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
}
.respond-complete-modal{
  position: absolute;
  max-width: 684px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #FFFFFF;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 45px 64px 60px 57px;
  width: 100%;
  max-height: 100vh;
  overflow-y: auto;
  @include mobile{
    padding: 20px;
  }
  &__title{
    margin: 0 0 36px;
  }
  &__text{
    font-size: 14px;
    line-height: 20px;
    color: #161515;
    margin-bottom: 12px;
  }
  &__subText{
    font-size: 12px;
    line-height: 16px;
    color: #68737D;
    margin-bottom: 29px;
  }
  :deep{
    .label{
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #68737D;
    }
    .field{
      margin-bottom: 0px;
    }
    .respond-complete-file{
      margin: 0 0 3px;
    }
  }
}
.respond-complete-reset{
  border: 1px solid #00A59E;
}
.respond-complete-add{
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #68737D;
  margin-bottom: 35px;
  cursor: pointer;
  &__icon{
    margin-right: 11px;
  }
}
.respond-complete-buttons{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 23px;
  margin-top: 24px;
  @include mobile{
    grid-template-columns: 1fr;
  }
}
.respond-complete-files{
  display: grid;
  grid-row-gap: 5px;
  margin-bottom: 15px;
}
</style>